import { createRouter as vueCreateRouter, createWebHistory } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';

export const createRouter = (routes: RouteRecordRaw[]) =>
  vueCreateRouter({
    history: createWebHistory(),
    routes
  });
